import { useContext } from 'react';
import { AirDropContext } from '../../utils/AirDropProvider';

export default function useFeatures() {
  const { logoTreatment } = useContext(AirDropContext);

  const isChannels = logoTreatment === 'channels';
  const isChannelsAlt = logoTreatment === 'channels_alt';
  const isPDotCom = logoTreatment === 'p_dot_com' || logoTreatment === 'reskin';
  const isTurbo = logoTreatment === 'turbo';

  const isLegacy = logoTreatment !== 'channels'
    && logoTreatment !== 'channels_alt'
    && logoTreatment !== 'p_dot_com'
    && logoTreatment !== 'turbo'
    && logoTreatment !== 'reskin';

  return {
    isChannels, isChannelsAlt, isPDotCom, isTurbo, isLegacy,
  };
}

// add new isHEDEvolution and isHEDEvolutionLight as features?
// isLegacy HAS TO REMAIN to reflect our HED partners
